import { module } from 'angular';
import App from '../../../app';

class SCR1902Controller {
	
	constructor ($scope, $state, $timeout, $uibModalInstance, httpService, utilService, gridService, popupService, data){
		this.$scope = $scope;
		this.$state = $state;
		this.$timeout = $timeout;
		this.$uibModalInstance = $uibModalInstance;
		this.httpService = httpService;
		this.utilService = utilService;
		this.gridService = gridService;
		this.popupService = popupService;
		this.data = data;
		
		if(!data.width) data.width = 950;
		if(!data.height) data.height = 700;
		
		this.initWindow(data.width, data.height);
		this.initText();
		this.initSelect();
		
		this.$timeout(() => {
			this.initIntrfcGridOption();
			this.getEffectList();
		});
	}
	
	initWindow(width, height){
		const { top, left } = this.popupService.calculatePosition(width,height);
		
		this.width = width;
		this.height = height;
		this.top = top;
		this.left = left;
		this.zIndex = this.popupService.getModalZIndex();
	}
	
	initText(){
		this.text = {
			metaEngNm : bxMsg('manageMetaInfo.metaEngNm'),
			metaKorNm : bxMsg('manageMetaInfo.metaKorNm'),
			metaLen : bxMsg('manageMetaInfo.metaLen'),
			decimalLen : bxMsg('manageMetaInfo.decimalLen'),
			dataTypeNm : bxMsg('manageMetaInfo.dataTypeNm'),
			influenceModal : bxMsg('manageMetaInfo.influenceModal'),
			intrfcId : bxMsg('manageMetaInfo.intrfcId'),
			intrfcNm : bxMsg('manageMetaInfo.intrfcNm'),
			intrfcType : bxMsg('manageMetaInfo.intrfcType'),
			msgId : bxMsg('manageMetaInfo.msgId'),
			alertConfirm : bxMsg('common.alertConfirm'),
			confirmOk : bxMsg('common.confirmOk'),
			confirmCancel : bxMsg('common.confirmCancel'),
			usedMsgMsg1: bxMsg('common.usedMsgMsg1'),
			usedMsgMsg2: bxMsg('common.usedMsgMsg2'),
			msgRegisterDt: bxMsg('common.msgRegisterDt'),
			lvCdsStr: bxMsg('manageMsg.lvCdsStr'),
			userId: bxMsg('manageUser.userId'),
			userNm: bxMsg('manageUser.userNm')
		};
	}
	
	initSelect(){
		this.select = this.gridService.getSelect(10);
	}
	
	initIntrfcGridOption(){
		this.gridView = new RealGridJS.GridView('grid');
		this.dataProvider = new RealGridJS.LocalDataProvider();
		this.gridView.setDataSource(this.dataProvider);		
		this.gridService.setDefaultSetting(this.gridView);
		this.gridView.setCheckBar({visible: false});
		this.gridView.setDisplayOptions({fitStyle: 'evenFill', vscrollBar: true, focusVisible: true, focusColor: '#aaa'}); 
		this.gridView.setSelectOptions({style: 'block'});
		
		this.dataProvider.setFields([
            {
            	fieldName: "no",
            	calculateCallback: (dataRow, fieldName, fieldNames, values) => {
            		return this.gridService.getNoField(this.select.pageSize, dataRow, this.pageNumber);
        		}
    		}, 
    		{fieldName: "intrfcId"}, {fieldName: "intrfcNm"}, {fieldName: "intrfcType"}, {fieldName: "msgLayoutId"},
    		{fieldName: "lv3Cd"}, {fieldName: "userId"}, {fieldName: "userNm"}, {fieldName: "regDttm"},
    		{
            	fieldName: "regDttmTxt",
            	calculateCallback: (dataRow, fieldName, fieldNames, values) => {
            		const regDttm = values[fieldNames.indexOf('regDttm')];
            		return this.utilService.setRegDttm(regDttm);
        		}
    		}, 
        ]);
		
		this.gridView.setColumns([
			{ name: "no", fieldName: "no", header : { text: "no" } , width: 40, styles: { textAlignment: 'center' } },
			{ name: "intrfcId", fieldName: "intrfcId", header : { text: this.text.intrfcId }, width: 120, styles: { textAlignment: 'center' } },
			{ name: "intrfcNm", fieldName: "intrfcNm", header : { text: this.text.intrfcNm }, width: 120, styles: { textWrap: 'ellipse' } },
			{ name: "lv3Cd", fieldName: "lv3Cd", header : { text: this.text.lvCdsStr }, width: 80, styles: { textAlignment: 'center' } },
			{ name: "intrfcType", fieldName: "intrfcType", header : { text: this.text.dataTypeNm }, width: 40, styles: { textAlignment: 'center' } },
			{ name: "msgLayoutId", fieldName: "msgLayoutId", header : { text: this.text.msgId }, width: 120, styles: { textAlignment: 'center' } },
			{ name: "userId", fieldName: "userId", header : { text: this.text.userId }, width: 80, styles: { textAlignment: 'center' } },
			{ name: "userNm", fieldName: "userNm", header : { text: this.text.userNm }, width: 80, styles: { textAlignment: 'center' } },
			{ name: "regDttmTxt", fieldName: "regDttmTxt", header : { text: this.text.msgRegisterDt }, width: 120, styles: { textAlignment: 'center' } }
		]);
	}
	
	getEffectList(){
		this.dataProvider.setRows(this.data.data);
	}
	
	closeModal(isOk){
		if(isOk){
			this.$uibModalInstance.close();
		} else {
			this.$uibModalInstance.dismiss();
		}
		
		this.gridView.destroy();
		this.dataProvider.destroy();
	}

}

module(App.name).controller('SCR1902Controller', SCR1902Controller);




// WEBPACK FOOTER //
// ./src/app/views/popup/SCR1902/SCR1902.controller.js